// test1294
(1294 && 0);
